import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-brand-navy text-brand-cream relative overflow-hidden"
        >
            <div className="bg-grid-navy absolute inset-0 opacity-40 pointer-events-none" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-16">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <div className="h-12 w-12 rounded-xl bg-white/5 ring-1 ring-white/10 grid place-items-center">
                                <img
                                    src="/assets/logo.png"
                                    alt="Fontanería Rodrigo"
                                    className="h-11 w-11 object-contain"
                                />
                            </div>
                            <div>
                                <div className="font-display font-bold text-xl leading-none">
                                    Fontanería Rodrigo <span className="opacity-60 font-normal">S.L.</span>
                                </div>
                                <div className="mt-1 text-xs uppercase tracking-[0.2em] text-brand-cream/60 font-semibold">
                                    Fontanería y calefacción
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-brand-cream/70 text-[15px] leading-relaxed max-w-md">
                            Servicios profesionales de fontanería y calefacción en Puente la Reina y toda Navarra. Calidad, cercanía y experiencia al servicio de tu hogar.
                        </p>
                        <p className="mt-6 text-xs text-brand-cream/50">CIF {BUSINESS.cif}</p>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="font-display font-semibold text-[15px] mb-4 text-brand-cream">
                            Contacto
                        </h4>
                        <ul className="space-y-3 text-[14px]">
                            <li>
                                <a
                                    href={BUSINESS.phoneHref}
                                    data-testid="footer-phone"
                                    className="inline-flex items-start gap-2 text-brand-cream/80 hover:text-white transition-colors"
                                >
                                    <Phone className="h-4 w-4 mt-0.5 text-brand-red" />
                                    <span>{BUSINESS.phone}</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BUSINESS.emailHref}
                                    data-testid="footer-email"
                                    className="inline-flex items-start gap-2 text-brand-cream/80 hover:text-white transition-colors break-all"
                                >
                                    <Mail className="h-4 w-4 mt-0.5 text-brand-red" />
                                    <span>{BUSINESS.email}</span>
                                </a>
                            </li>
                            <li className="flex items-start gap-2 text-brand-cream/80">
                                <MapPin className="h-4 w-4 mt-0.5 text-brand-red shrink-0" />
                                <span>
                                    {BUSINESS.address}
                                    <br />
                                    {BUSINESS.postalCode} {BUSINESS.city}, {BUSINESS.province}
                                </span>
                            </li>
                            <li className="flex items-start gap-2 text-brand-cream/80">
                                <Clock className="h-4 w-4 mt-0.5 text-brand-red shrink-0" />
                                <span>{BUSINESS.hours}</span>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="font-display font-semibold text-[15px] mb-4 text-brand-cream">
                            Servicios
                        </h4>
                        <ul className="space-y-2 text-[14px] text-brand-cream/70">
                            <li><a href="/#servicios" className="hover:text-white">Calderas</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Calefacción</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Radiadores</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Suelo radiante</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Aerotermia</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Gas</a></li>
                            <li><a href="/#servicios" className="hover:text-white">Baños</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="font-display font-semibold text-[15px] mb-4 text-brand-cream">
                            Legal
                        </h4>
                        <ul className="space-y-2 text-[14px] text-brand-cream/70">
                            <li>
                                <Link
                                    to="/aviso-legal"
                                    data-testid="footer-aviso-legal"
                                    className="hover:text-white"
                                >
                                    Aviso legal
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/politica-privacidad"
                                    data-testid="footer-privacidad"
                                    className="hover:text-white"
                                >
                                    Política de privacidad
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/politica-cookies"
                                    data-testid="footer-cookies"
                                    className="hover:text-white"
                                >
                                    Política de cookies
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[13px] text-brand-cream/50">
                    <p>© {new Date().getFullYear()} Fontanería Rodrigo S.L. · Todos los derechos reservados.</p>
                    <p className="flex items-center gap-2">
                        <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-red" />
                        Hecho con dedicación en Navarra
                    </p>
                </div>
            </div>
        </footer>
    );
}
